export interface ParticipationByProductDate {
  currentParticipantCount: number
  originalParticipantCount: number
  saleItemId: number
  targetLinkedProductId: number
  state?: CellState
}
export enum CellState {
  AVAILABLE = 'available',
  BOOKED = 'booked',
  OCCUPIED = 'occupied',
  UNAVAILABLE = 'unavailable'
}
